
/**
 * @nullable
 */
export type ArticleInstancePlacementSourceType = typeof ArticleInstancePlacementSourceType[keyof typeof ArticleInstancePlacementSourceType] | null;


export const ArticleInstancePlacementSourceType = {
  Panel: 'Panel',
  UnsavedGroup: 'UnsavedGroup',
  SavedGroup: 'SavedGroup',
  Corner: 'Corner',
  Gap: 'Gap',
} as const;
